import { Navigate } from 'react-router-dom';

import Private from 'components/Private';
import {
	DashboardRoute,
	LinkedMembersManagementRoute,
	LoginRoute,
	OnboardingRoute,
	RenewMemberRoute,
	SignUpRoute,
	ErrorRoute
} from 'routes';
import { isValidToken } from 'utils';
import { LINKS } from 'constants/links';

const NonAuth = ({ children }) => {
	const isAuth = isValidToken();

	return isAuth ? <Navigate to="/dashboard" /> : children;
};

export const getRoutes = () => {
	return [
		{
			path: LINKS.SIGNUP,
			element: (
				<NonAuth>
					<SignUpRoute />
				</NonAuth>
			)
		},
		{
			path: LINKS.LOGIN,
			element: (
				<NonAuth>
					<LoginRoute />
				</NonAuth>
			)
		},
		{ path: LINKS.SYSTEM_ERROR, element: <ErrorRoute /> },
		{
			path: LINKS.APP,
			element: <Private />,
			children: [
				{ path: LINKS.APP, index: true, element: <Navigate to={LINKS.DASHBOARD} replace /> },
				{ path: LINKS.DASHBOARD, element: <DashboardRoute /> },
				{ path: LINKS.ONBOARDING, element: <OnboardingRoute /> },
				{ path: LINKS.RENEW_MEMBER, element: <RenewMemberRoute /> },
				{ path: LINKS.LINKED_MEMBERS, element: <LinkedMembersManagementRoute /> },
				{ path: LINKS.ALL, element: <Navigate to={LINKS.DASHBOARD} replace /> }
			]
		}
	];
};
